import { render, staticRenderFns } from "./rollSuit.vue?vue&type=template&id=c2d54cb2&"
import script from "./rollSuit.vue?vue&type=script&lang=js&"
export * from "./rollSuit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2d54cb2')) {
      api.createRecord('c2d54cb2', component.options)
    } else {
      api.reload('c2d54cb2', component.options)
    }
    module.hot.accept("./rollSuit.vue?vue&type=template&id=c2d54cb2&", function () {
      api.rerender('c2d54cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/componetsPage/rollSuit.vue"
export default component.exports